// extracted by mini-css-extract-plugin
module.exports = {"Title":"bookmarks-news-list_Title__6O_4I"};